import React from 'react';
import { ControlLink, LoadingBalls, Overlay, Text } from '@moda/om';
import { noop } from '@moda/portal-stanchions';
import { useAuth } from '../../hooks/useAuth';
import { AuthAction, AuthPayloadSuccess } from '../../lib/authenticate';

type ContinueAsGuestButtonProps = {
  email: string;
  onAuth: (authUser?: AuthPayloadSuccess) => void;
  optedIn: boolean;
};

export const ContinueAsGuestButton: React.FC<ContinueAsGuestButtonProps> = ({
  email,
  onAuth,
  optedIn
}) => {
  const { error, handleAuth, loading } = useAuth(AuthAction.Register);

  const handleGuestCheckout = () => {
    handleAuth({
      guest: true,
      email,
      remember: true,
      opted_in: optedIn
    })
      .then(onAuth)
      .catch(noop);
  };

  return (
    <>
      {error?.message && (
        <div className="Authentication__error" role="alert">
          {error.message}
        </div>
      )}

      <ControlLink
        onClick={handleGuestCheckout}
        disabled={loading}
        type="button"
        data-testid="guestSubmit"
      >
        Continue as Guest
      </ControlLink>

      <Overlay className="Authentication__overlay" show={loading}>
        <LoadingBalls />

        <Text treatment="eyebrow">Loading</Text>
      </Overlay>
    </>
  );
};
